import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class InformationBlock extends Vue {
  @Prop({ default: false }) public isHtml?: boolean;
  @Prop({ required: true }) public contentKey!: string;

  public get isContentEmpty(): boolean {
    const translation = this.$t(this.contentKey).toString();
    return (translation === '' || translation === this.contentKey) ? true : false;
  }
}
